import { create } from 'zustand';
import { ReturnFilterForm, ReturnSearchForm } from 'types';
import { getTodayStoredData, removeLocalStorageItem } from 'helpers';
import {
  LocalStorageKeys,
  getDefaultReturnFilter,
  getDefaultReturnSearch,
} from 'commons';

interface Store {
  returnFilter: ReturnFilterForm;
  returnSearch: ReturnSearchForm;
  filteredBrand: string;
  filteredStore: string;
}

interface Actions {
  reset: ({ brand, store }: { brand?: string; store?: string }) => void;
  setReturnFilter: (returnFilter: ReturnFilterForm) => void;
  setReturnSearch: (returnSearch: ReturnSearchForm) => void;
  setFilteredStore: (filteredStore: string) => void;
  setFilteredBrand: (filteredBrand: string) => void;
}

const defaultReturnSearch = getDefaultReturnSearch();
const defaultReturnFilter = getDefaultReturnFilter();

const initialState: Store = {
  returnFilter: getTodayStoredData<ReturnFilterForm>(
    LocalStorageKeys.ReturnFilter,
    defaultReturnFilter
  ),
  returnSearch: getTodayStoredData<ReturnSearchForm>(
    LocalStorageKeys.ReturnSearch,
    defaultReturnSearch
  ),
  filteredStore: '',
  filteredBrand: '',
};

const useStore = create<Store & Actions>((set, get) => ({
  ...initialState,
  reset: ({ brand, store }) => {
    removeLocalStorageItem(LocalStorageKeys.ReturnSearch);
    removeLocalStorageItem(LocalStorageKeys.ReturnFilter);
    set({
      ...initialState,
      filteredStore: store || '',
      filteredBrand: brand || '',
    });
  },
  setReturnFilter: (returnFilter: ReturnFilterForm) =>
    set(() => {
      const { returnStatuses } = returnFilter;

      return {
        returnFilter: {
          ...returnFilter,
          returnStatuses: returnStatuses.sort(),
        },
      };
    }),
  setReturnSearch: (returnSearch: ReturnSearchForm) =>
    set(() => ({ returnSearch })),
  setFilteredStore: (filteredStore: string) => set(() => ({ filteredStore })),
  setFilteredBrand: (filteredBrand: string) => set(() => ({ filteredBrand })),
}));

export const ReturnFilterStore = {
  useStore,
};
